"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var js_api_loader_1 = require("@googlemaps/js-api-loader");
var markerclusterer_1 = require("@googlemaps/markerclusterer");
var GoogleMapsClusterRenderer_1 = __importDefault(require("./GoogleMapsClusterRenderer"));
var constantsClasses_1 = require("../data/constantsClasses");
var GoogleMapsBox = /** @class */ (function () {
    function GoogleMapsBox() {
        var _this = this;
        var _a;
        this.initialized = false;
        this.locationfinderMapContainer =
            document.querySelector('[data-locationfinder-map]');
        if (!this.locationfinderMapContainer) {
            return;
        }
        // If consent already exists -> build map immediately.
        // Otherwise wait until consent is given.
        var allowed = ((_a = window.OnetrustActiveGroups) !== null && _a !== void 0 ? _a : '').includes('C0010');
        if (allowed) {
            this.createLoaderOnce();
        }
        else {
            document.addEventListener('externalMediaAccepted', function () { return _this.createLoaderOnce(); }, { once: true });
        }
    }
    GoogleMapsBox.prototype.createLoaderOnce = function () {
        if (this.initialized)
            return;
        this.initialized = true;
        this.createLoader();
    };
    GoogleMapsBox.prototype.createLoader = function () {
        var _this = this;
        if (!this.locationfinderMapContainer)
            return;
        var loader = new js_api_loader_1.Loader({
            apiKey: this.locationfinderMapContainer.dataset.locationfinderApiKey,
            version: 'weekly',
        });
        loader.importLibrary('maps').then(function () { return __awaiter(_this, void 0, void 0, function () {
            var Map, AdvancedMarkerElement, map, locations, markers, bounds, clusterer;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, google.maps.importLibrary('maps')];
                    case 1:
                        Map = (_a.sent()).Map;
                        return [4 /*yield*/, google.maps.importLibrary('marker')];
                    case 2:
                        AdvancedMarkerElement = (_a.sent()).AdvancedMarkerElement;
                        map = new Map(this.locationfinderMapContainer, {
                            center: { lat: 39, lng: -25 },
                            zoom: 2,
                            mapId: 'googleMapsBox',
                            zoomControl: true,
                            disableDoubleClickZoom: true,
                            mapTypeControl: true,
                            scaleControl: true,
                            scrollwheel: false,
                            streetViewControl: true,
                            mapTypeId: google.maps.MapTypeId.ROADMAP,
                        });
                        locations = document.querySelectorAll('[data-locationfinder-index]');
                        markers = [];
                        bounds = new google.maps.LatLngBounds();
                        locations.forEach(function (location) {
                            var locationIndex = Number.parseInt(location.dataset.locationfinderIndex || '0');
                            var locationLng = Number.parseFloat(location.dataset.locationfinderLng || '0');
                            var locationLat = Number.parseFloat(location.dataset.locationfinderLat || '0');
                            if (locationLng <= 0.001 && locationLat <= 0.001)
                                return;
                            var locationPin = document.createElement('div');
                            locationPin.className = 'location-pin';
                            locationPin.textContent = String(locationIndex);
                            var marker = new AdvancedMarkerElement({
                                map: map,
                                position: { lng: locationLng, lat: locationLat },
                                content: locationPin,
                                title: location.dataset.locationfinderTooltip,
                            });
                            marker.addListener('click', function () {
                                // Remove all active classes
                                locations.forEach(function (locationItem) {
                                    locationItem.classList.remove(constantsClasses_1.CLASS_ACTIVE);
                                });
                                location.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'center',
                                    inline: 'nearest',
                                });
                                // Set active class for clicked element
                                location.classList.add(constantsClasses_1.CLASS_ACTIVE);
                            });
                            markers.push(marker);
                            //bounds.extend(marker.position as any);
                            var pos = marker.position;
                            if (pos)
                                bounds.extend(pos);
                        });
                        clusterer = new markerclusterer_1.MarkerClusterer({
                            map: map,
                            markers: markers,
                            renderer: new GoogleMapsClusterRenderer_1.default(),
                        });
                        // Remove all active classes on cluster click
                        clusterer.addListener('click', function () {
                            locations.forEach(function (locationItem) {
                                locationItem.classList.remove(constantsClasses_1.CLASS_ACTIVE);
                            });
                        });
                        // If only one marker exists, set a initial maximum zoom
                        if (markers.length === 1) {
                            map.setCenter(bounds.getCenter());
                            map.setZoom(10);
                        }
                        else if (markers.length === 0) {
                            map.setZoom(3);
                            map.setCenter({ lat: 51, lng: 10 });
                        }
                        else {
                            map.fitBounds(bounds);
                        }
                        return [2 /*return*/];
                }
            });
        }); });
    };
    return GoogleMapsBox;
}());
exports.default = GoogleMapsBox;
